import { Link } from "react-router-dom";
import { Star, MapPin, BadgeCheck, MessageCircle, Sparkles } from "lucide-react";

export default function HoomanCard({ u }) {
  const cats = (u.categories?.length ? u.categories : (u.category ? [u.category] : [])).slice(0, 3);
  return (
    <div className="card overflow-hidden block rise" data-testid={`hooman-card-${u.id}`}>
      <Link to={`/u/${u.id}`} className="block">
        <div className="relative h-56 bg-[#F2F2F0]">
          {u.cover && <img src={u.cover} alt="" className="absolute inset-0 w-full h-full object-cover" />}
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/40 to-transparent" />
          {u.is_sponsored && (
            <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#0A0A0A] text-white text-[11px] font-medium" data-testid={`sponsored-badge-${u.id}`}>
              <Sparkles size={10}/> Sponsored
            </span>
          )}
          <div className="absolute left-5 -bottom-7 flex items-end gap-3">
            {u.avatar && <img src={u.avatar} alt={u.name} className="h-16 w-16 rounded-full border-4 border-white object-cover" />}
          </div>
        </div>
        <div className="px-6 pt-10 pb-5">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-heading text-xl truncate">{u.name}</h3>
            {u.is_verified && <span className="badge badge-verified shrink-0"><BadgeCheck size={12}/> Verified</span>}
          </div>
          <div className="flex flex-wrap gap-1.5 mt-2.5" data-testid={`card-categories-${u.id}`}>
            {cats.map((c,i) => (
              <span key={i} className={`text-xs px-2.5 py-1 rounded-full ${i===0 ? "bg-[#0A0A0A] text-white" : "bg-[#F2F2F0] text-[#0A0A0A]"}`}>{c}</span>
            ))}
            {(u.categories?.length||0) > 3 && <span className="text-xs px-2.5 py-1 rounded-full bg-[#F2F2F0] text-[#0A0A0A]">+{u.categories.length-3}</span>}
          </div>
          <p className="text-sm text-[#4A4A4A] mt-3 line-clamp-2">{u.bio}</p>
          <div className="flex items-center justify-between mt-5 text-sm text-[#4A4A4A]">
            <span className="inline-flex items-center gap-1.5"><MapPin size={14}/> {u.location || "—"}</span>
            <span className="inline-flex items-center gap-1.5"><Star size={14} className="fill-[#0057FF] stroke-[#0057FF]"/> {u.trust_score?.toFixed?.(1) || u.trust_score}</span>
          </div>
        </div>
      </Link>
      <div className="px-6 pb-5 -mt-1 flex gap-2">
        <Link to={`/u/${u.id}`} className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-full bg-[#0A0A0A] text-white text-sm hover:bg-[#1F1F1F]" data-testid={`card-view-${u.id}`}>View</Link>
        <Link to={`/messages/${u.id}`} className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-full border border-[#E5E5E3] text-sm hover:bg-[#F2F2F0]" data-testid={`card-message-${u.id}`}>
          <MessageCircle size={14}/> Message
        </Link>
      </div>
    </div>
  );
}
